module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.data !== null) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('div', {
    staticClass: "fade-in-down"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v("Comitente")]), _vm._v(" "), _c('span', {
    staticClass: "label no-radius bg-dark"
  }), _vm._v(" "), _c('span', {
    staticClass: "label m-l-n-xxs no-radius bg-success"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "visible-xs m-t-lg"
  }), _vm._v(" "), _c('u-button', {
    staticClass: "btn btn-sm btn-info pull-right pull-none-xs hidden-print",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.print($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print m-r-xs"
  }), _vm._v(" Imprimir\n            ")]), _vm._v(" "), _c('u-button', {
    staticClass: "btn btn-sm btn-default pull-right pull-none-xs m-r-sm hidden-print",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.editar($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit m-r-xs"
  }), _vm._v(" Editar\n            ")]), _vm._v(" "), _c('u-button', {
    staticClass: "btn btn-sm btn-default btn-danger pull-right pull-none-xs m-r-sm hidden-print",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deletar($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit m-r-xs"
  }), _vm._v(" Deletar\n            ")]), _vm._v(" "), _c('router-link', {
    staticClass: "pull-right pull-none-xs hidden-print m-t-xs m-r",
    staticStyle: {
      "clear": "left"
    },
    attrs: {
      "to": {
        name: 'comitentes'
      }
    }
  }, [_c('strong', {
    staticClass: "label no-radius bg-info"
  }, [_vm._v("Voltar")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "panel panel-default pos-rlt",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('div', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.data.imagemUrl
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "300px"
    },
    attrs: {
      "src": _vm.data.imageInfo && _vm.data.imageInfo.thumb.url || _vm.data.imagemUrl
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isUploadingImage),
      expression: "isUploadingImage"
    }],
    staticClass: "progress progress-xs bg-white-opacity m-b-none",
    staticStyle: {
      "margin-top": "-6px",
      "z-index": "999",
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "progress-bar bg-info",
    style: ('width:' + _vm.uploadingImageStatus.percent + '%;')
  })]), _vm._v(" "), _c('div', {
    staticClass: "panel-footer bg-light lter"
  }, [_c('ul', {
    staticClass: "nav nav-pills nav-sm hidden-print"
  }, [_c('li', {
    staticClass: "m-r"
  }, [_c('a', {
    staticClass: "fileContainer",
    attrs: {
      "href": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-camera text-muted"
  }), _vm._v(" "), _c('input', {
    attrs: {
      "accept": "image/*",
      "type": "file"
    },
    on: {
      "change": _vm.carregarImagem
    }
  })])]), _vm._v(" "), _c('li', [_c('label', {
    staticClass: "i-switch bg-success m-t-xs m-r"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.mostrarLogo),
      expression: "data.mostrarLogo"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.mostrarLogo) ? _vm._i(_vm.data.mostrarLogo, null) > -1 : (_vm.data.mostrarLogo)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.mostrarLogo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "mostrarLogo", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "mostrarLogo", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "mostrarLogo", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('i')])])])])]), _vm._v(" "), _c('div', {
    staticClass: "m-t-n m-b"
  }, [_c('small', {
    staticClass: "font-thin m-t-n"
  }, [_vm._v("Resolução: 200x81px")])]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.data.pessoa.nome))]), _vm._v(" "), (_vm.data.grupo) ? _c('p', [_vm._v("Grupo " + _vm._s(_vm.data.grupo.nome))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.enderecoPrincipal), function(endereco) {
    return _c('p', [_vm._v("\n              " + _vm._s(endereco.logradouro) + _vm._s(endereco.numero && ', ' + endereco.numero) + " " + _vm._s(endereco.complemento &&
      endereco.complemento) + " "), _c('br'), _vm._v("\n              " + _vm._s(endereco.bairro) + " " + _vm._s(endereco.cep ? ', ' + endereco.cep : '')), _c('br'), _vm._v("\n              " + _vm._s(endereco.municipio ? endereco.municipio.nome : endereco.cidadeOutros) + ", " + _vm._s(endereco.municipio &&
      endereco.municipio.uf ? endereco.municipio.uf.nome : endereco.ufOutros) + "\n            ")])
  }), _vm._v(" "), _vm._l((_vm.outrosEnderecos), function(endereco) {
    return _c('p', {
      staticClass: "b-t"
    }, [_vm._v("\n              " + _vm._s(endereco.logradouro) + _vm._s(endereco.numero && ', ' + endereco.numero) + " " + _vm._s(endereco.complemento &&
      endereco.complemento) + " "), _c('br'), _vm._v("\n              " + _vm._s(endereco.bairro)), _c('br'), _vm._v("\n              " + _vm._s(endereco.municipio ? endereco.municipio.nome : endereco.cidadeOutros) + ", " + _vm._s(endereco.municipio &&
      endereco.municipio.uf ? endereco.municipio.uf.nome : endereco.ufOutros) + "\n            ")])
  }), _vm._v(" "), _c('p', _vm._l((_vm.data.pessoa.telefones), function(telefone) {
    return _c('span', [_vm._v("Telefone: " + _vm._s(_vm._f("formataTelefone")(telefone.telefone))), (telefone.celular) ? _c('i', {
      staticClass: "fa fa-mobile-phone m-l-xs"
    }) : _vm._e(), _vm._v(" "), _c('br')])
  }), 0), _vm._v(" "), (_vm.data.pessoa.emails && _vm.data.pessoa.emails.length > 0) ? _c('p', [_vm._v("\n              Email" + _vm._s(_vm.data.pessoa.emails && _vm.data.pessoa.emails.length > 1 ? 's' : '') + ": "), _c('span', [_vm._v(_vm._s(_vm.getEmails))])]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("\n              IP origem cadastro: "), _c('span', [_vm._v(_vm._s(_vm.data.pessoa.ipCadastro))])]), _vm._v(" "), (_vm.data.pessoa.observacao) ? _c('p', [_vm._v("\n              Observações:"), _c('br'), _c('br'), _vm._v("\n              " + _vm._s(_vm.data.pessoa.observacao) + "\n            ")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-right text-left-print"
  }, [_c('p', {
    staticClass: "h4"
  }, [_vm._v("#" + _vm._s(_vm.data.id))]), _vm._v(" "), _c('h5', [_vm._v("Cadastro realizado" + _vm._s(_vm.data.pessoa.origem ? ' pelo ' + _vm.data.pessoa.origem.origem.toLowerCase() :
    '') + " " + _vm._s(_vm.moment(_vm.data.pessoa.dataCadastro.date).format('LLLL')))]), _vm._v(" "), _c('div', [_vm._v("\n              " + _vm._s(_vm.data.pessoa.tipo === 1 ? 'Pessoa Física' : 'Pessoa Jurídica')), _c('br'), _vm._v(" "), (_vm.data.pessoa.tipo === 1) ? _c('div', [_vm._v("\n                CPF: "), (_vm.data.pessoa.cpf) ? _c('span', [_vm._v(_vm._s(_vm._f("formataCpf")(_vm.data.pessoa.cpf)))]) : _c('span', [_vm._v("Sem CPF")]), _c('br'), _vm._v("\n                RG: " + _vm._s(_vm.data.pessoa.pfRg) + " " + _vm._s(_vm.data.pessoa.pfRgOrgaoEmissor) + " " + _vm._s(_vm.data.pessoa.pfRgDataExpedicao)), _c('br'), _vm._v("\n                Nascimento: "), (_vm.data.pessoa.pfDataNascimento) ? _c('span', [_vm._v(_vm._s(_vm.moment(_vm.data.pessoa.pfDataNascimento.date).format('L')) + ", " + _vm._s(_vm._f("moment")(_vm.data.pessoa.pfDataNascimento.date)))]) : _vm._e(), _c('br'), _vm._v("\n                Estado Civil: " + _vm._s(_vm.Status().EstadoCivil[_vm.data.pessoa.pfEstadoCivil])), _c('br'), _vm._v("\n                Sexo: " + _vm._s(_vm.data.pessoa.pfSexo === 1 ? 'Masculino' : 'Feminino')), _c('br'), _vm._v(" "), (_vm.data.conjugeNome) ? _c('div', [_vm._v("\n                  Cônjuge: " + _vm._s(_vm.data.conjugeNome)), _c('br'), _vm._v("\n                  CPF Cônjuge: "), (_vm.data.conjugeCpf) ? _c('span', [_vm._v(_vm._s(_vm._f("formataCpf")(_vm.data.conjugeCpf)))]) : _c('span', [_vm._v("Sem CPF")]), _c('br'), _vm._v("\n                  RG Cônjuge: "), (_vm.data.conjugeRg) ? _c('span', [_vm._v(_vm._s(_vm.data.conjugeRg))]) : _c('span', [_vm._v("Sem RG")]), _c('br')]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.data.pessoa.tipo === 2) ? _c('div', [_vm._v("\n                CNPJ: "), (_vm.data.pessoa.cnpj) ? _c('span', [_vm._v(_vm._s(_vm._f("formataCnpj")(_vm.data.pessoa.cnpj)))]) : _c('span', [_vm._v("Sem CNPJ")]), _c('br'), _vm._v("\n                Inscrição Estadual: " + _vm._s(_vm.data.pessoa.pjInscricaoEstadual)), _c('br'), _vm._v("\n                Nome Fantasia: " + _vm._s(_vm.data.pessoa.pjNomeFantasia)), _c('br'), _vm._v("\n                Razão Social: " + _vm._s(_vm.data.pessoa.pjRazaoSocial)), _c('br'), _vm._v("\n                Responsável: " + _vm._s(_vm.data.pessoa.pjResponsavel || _vm.data.pjProprietarioNome)), _c('br'), _vm._v("\n                CPF: "), (_vm.data.pjProprietarioCpf) ? _c('span', [_vm._v(_vm._s(_vm._f("formataCpf")(_vm.data.pjProprietarioCpf)))]) : _c('span', [_vm._v("SEM CPF DO RESPONSÁVEL")])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "shell-wrap"
  }, [_c('p', {
    staticClass: "shell-top-bar"
  }, [_vm._v("Sistema de Acesso")]), _vm._v(" "), _c('ul', {
    staticClass: "shell-body",
    staticStyle: {
      "min-height": "200px"
    }
  }, [_c('li', {
    staticClass: "salert"
  }, [_c('table', {
    staticClass: "table-shell"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("CONTA")]), _vm._v(" "), _c('th', [_vm._v("LOGIN")]), _vm._v(" "), _c('th', [_vm._v("EMAIL")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.data.usuarios), function(usuario, key) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(key + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(usuario.username))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(usuario.email))])])
  }), _vm._v(" "), (!_vm.data.usuarios || _vm.data.usuarios.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Não existe conta de acesso para este comitente")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dAlterarSenha.etapa > 0),
      expression: "dAlterarSenha.etapa > 0"
    }],
    staticClass: "m-t"
  }, [_vm._v("\n            Digite a conta que deseja efetuar a operação:\n            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dAlterarSenha.conta),
      expression: "dAlterarSenha.conta"
    }],
    ref: "senha1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dAlterarSenha.conta)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.alterarSenhaEtapa(2)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dAlterarSenha, "conta", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dAlterarSenha.etapa > 1),
      expression: "dAlterarSenha.etapa > 1"
    }]
  }, [_vm._v("\n            Digite a nova senha\n            "), _c('i', {
    staticClass: "text-white"
  }, [_vm._v("(deixe em branco para gerar automaticamente)")]), _vm._v(":\n            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dAlterarSenha.senha),
      expression: "dAlterarSenha.senha"
    }],
    ref: "senha2",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.dAlterarSenha.senha)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.alterarSenha($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dAlterarSenha, "senha", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.criarUsuario.etapa > 0),
      expression: "criarUsuario.etapa > 0"
    }],
    staticClass: "m-t"
  }, [_vm._v("\n            Digite o novo login:\n            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.criarUsuario.conta),
      expression: "criarUsuario.conta"
    }],
    ref: "usuario1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.criarUsuario.conta)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.criaUsuarioEtapa(2)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.criarUsuario, "conta", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.criarUsuario.etapa > 1),
      expression: "criarUsuario.etapa > 1"
    }]
  }, [_vm._v("\n            E-mail:\n            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.criarUsuario.email),
      expression: "criarUsuario.email"
    }],
    ref: "usuario2",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.criarUsuario.email)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.criaUsuarioEtapa(3)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.criarUsuario, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.criarUsuario.etapa > 2),
      expression: "criarUsuario.etapa > 2"
    }]
  }, [_vm._v("\n            Digite a nova senha\n            "), _c('i', {
    staticClass: "text-white"
  }, [_vm._v("(deixe em branco para gerar automaticamente)")]), _vm._v(":\n            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.criarUsuario.senha),
      expression: "criarUsuario.senha"
    }],
    ref: "usuario3",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.criarUsuario.senha)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.criaUsuario($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.criarUsuario, "senha", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.removerUsuario.etapa > 0),
      expression: "removerUsuario.etapa > 0"
    }],
    staticClass: "m-t"
  }, [_vm._v("\n            Digite o login:\n            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.removerUsuario.conta),
      expression: "removerUsuario.conta"
    }],
    ref: "usuarioRemove1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.removerUsuario.conta)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.removeUsuarioEtapa(2)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.removerUsuario, "conta", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.removerUsuario.etapa > 1),
      expression: "removerUsuario.etapa > 1"
    }]
  }, [_vm._v("\n            Tem certeza que deseja remover a conta "), _c('strong', [_vm._v(_vm._s(_vm.removerUsuario.conta))]), _vm._v(" "), _c('span', {
    staticClass: "text-warning"
  }, [_vm._v("(S/N)")]), _vm._v(":\n            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.removerUsuario.confirmar),
      expression: "removerUsuario.confirmar"
    }],
    ref: "usuarioRemove2",
    attrs: {
      "size": "2",
      "maxlength": "1",
      "type": "text"
    },
    domProps: {
      "value": (_vm.removerUsuario.confirmar)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.removeUsuario($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.removerUsuario, "confirmar", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._l((_vm.saLogs), function(m) {
    return _c('li', {
      staticClass: "salert",
      domProps: {
        "innerHTML": _vm._s(m.message)
      }
    })
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "m-t"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.criaUsuarioEtapa(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user m-r-sm"
  }), _vm._v(" Criar novo\n          usuário")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.alterarSenhaEtapa(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lock m-r-sm"
  }), _vm._v(" Alterar senha")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger btn-sm",
    on: {
      "click": function($event) {
        return _vm.removeUsuarioEtapa(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove m-r-sm"
  }), _vm._v(" Remover\n          uma conta")])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c4d8531","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/comitentes/components/VisualizarComitente.vue
// module id = 1557
// module chunks = 17